module.exports = __webpack_public_path__ + "img/russland_von_oben_de.4151eecc.png";